import { createStaticPropsGetter,Page } from "../libs/pages";

export const getStaticProps = createStaticPropsGetter("conditions-generales");

export default Page;
